import { render, staticRenderFns } from "./RaceRunners.vue?vue&type=template&id=18e82dab&scoped=true"
import script from "./RaceRunners.vue?vue&type=script&lang=js"
export * from "./RaceRunners.vue?vue&type=script&lang=js"
import style0 from "./RaceRunners.vue?vue&type=style&index=0&id=18e82dab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e82dab",
  null
  
)

export default component.exports